import {Pipe,PipeTransform} from '@angular/core';
import {FinscanStatus} from '../model/finscan-status.enum';

@Pipe({
    name: "finscanStatus",
    pure:true
})
export class FinscanStatusPipe implements PipeTransform{
   
   
    transform(status: any,...args: any[]) {
        if(status==null||status==undefined) {
            return 'Not Screened';
            } else {
            switch(status) {
                case 'PASS':
                    return FinscanStatus.PASS;
                case 'MAYBE':
                    return FinscanStatus.MAYBE;
                case 'FULL_MATCH':
                    return FinscanStatus.FULL_MATCH;
                case 'TIMEOUT':
                    return FinscanStatus.TIMEOUT;
                case 'NOT_SCREENED':
                default:
                    return FinscanStatus.NOT_SCREENED;
            }
        }

    }


    

}